import React from 'react';
import '../App.css';

//	--------------------------------------------------------------------------
//
//	T Y P E S
//
//	--------------------------------------------------------------------------

import { Site } from '../utils/types';

//	--------------------------------------------------------------------------
//
//	R E D U X   S T A T E   M A N A G E M E N T
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	F U N C T I O N S
//
//	--------------------------------------------------------------------------

import { siteName } from '../utils/functions';

//	--------------------------------------------------------------------------
//
//	C L A S S   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

export default function SiteIcon(props: { site?: Site; size: number }) {
  //
  //	--------------------------------------------------------------------------
  //
  //	R E D U X   S T A T E   H A N D L I N G
  //
  //	--------------------------------------------------------------------------

  //	------------------------------------------------------------
  //
  //	C O M P O N E N T   C O D E
  //
  //	------------------------------------------------------------

  return (
    <div
      style={{
        flex: '0 0 ' + props.size.toString() + 'px',
        width: props.size.toString() + 'px',
        height: props.size.toString() + 'px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {(props.site?.icon ?? undefined) !== undefined &&
      (props.site?.icon ?? '') !== '' ? (
        <img
          style={{
            userSelect: 'none',
            border: 'none',
            borderRadius: '4px',
          }}
          src={props.site?.icon ?? undefined}
          alt={siteName({ site: props.site }).substring(0, 1).toUpperCase()}
          width={props.size.toString()}
          height={props.size.toString()}
        />
      ) : (
        <div
          className="text-colour"
          style={{
            width: props.size.toString() + 'px',
            flex: '0 0 ' + props.size.toString() + 'px',
            fontSize: Math.round((props.size * 2.0) / 3.0).toString() + 'pt',
            display: 'flex',
            justifyContent: 'center',
            userSelect: 'none',
            borderRadius: '4px',
            border: 'none',
          }}
        >
          {siteName({ site: props.site }).substring(0, 1).toUpperCase()}
        </div>
      )}
    </div>
  );
  //
} // Tool
